/**
 * Equa Design System - Generated Theme Values
 * Generated from design-tokens.json — do not edit directly
 *
 * Import these constants in theme.ts to replace hardcoded values.
 * Run `npm run tokens` to regenerate after editing design-tokens.json.
 */

// Base colors (dark theme defaults)
export const COLOR_BASE_DARK_NAVY = '#262A36';
export const COLOR_BASE_NAVY = '#2C3040';
export const COLOR_BASE_LIGHT_NAVY = '#394E5B';
export const COLOR_BASE_WHITE = '#ffffff';
export const COLOR_BASE_GRAY = '#f4f4f4';
export const COLOR_BASE_BLACK = '#000000';
export const COLOR_SEMANTIC_ERROR = '#D0021B';
export const COLOR_SEMANTIC_ERROR_LIGHT = '#FF5656';
export const COLOR_SEMANTIC_ERROR_BACK = '#FFD7D7';
export const COLOR_SEMANTIC_SUCCESS = '#33AA40';
export const COLOR_SEMANTIC_SUCCESS_LIGHT = '#A9F3B0';
export const COLOR_SEMANTIC_WARNING = '#F5A623';
export const COLOR_SEMANTIC_INFO = '#3292C0';
export const COLOR_BRAND_PRIMARY = '#33AA40';
export const COLOR_BRAND_PRIMARY_HOVER = '#0E7923';
export const COLOR_BRAND_PRIMARY_ACTIVE = '#007A0F';
export const COLOR_BRAND_SECONDARY = '#394E5B';
export const COLOR_BRAND_ACCENT = '#3292C0';
export const COLOR_UI_BACKGROUND = '#1F313A';
export const COLOR_UI_SURFACE = '#263946';
export const COLOR_UI_SURFACE_HOVER = '#394E5B';
export const COLOR_UI_BORDER = '#435763';
export const COLOR_UI_DIVIDER = '#435763';
export const COLOR_UI_INPUT = '#435763';
export const COLOR_UI_INPUT_DISABLED = 'rgba(81, 111, 119, 0.1)';
export const COLOR_TEXT_PRIMARY = '#e4e4e7';
export const COLOR_TEXT_STRONG = '#ffffff';
export const COLOR_TEXT_SECONDARY = '#9CA6AD';
export const COLOR_TEXT_MUTED = '#71717a';
export const COLOR_TEXT_DISABLED = 'rgba(191, 191, 191, 0.4)';
export const COLOR_TEXT_INVERSE = '#262626';

// Border radius
export const RADIUS_NONE = '0';
export const RADIUS_SM = '6px';
export const RADIUS_MD = '8px';
export const RADIUS_LG = '12px';
export const RADIUS_XL = '16px';
export const RADIUS_FULL = '9999px';

// Shadows
export const SHADOW_SM = '0 1px 2px rgba(0, 0, 0, 0.2)';
export const SHADOW_MD = '0 4px 12px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(255, 255, 255, 0.03)';
export const SHADOW_LG = '0 12px 28px rgba(0, 0, 0, 0.35), 0 0 0 1px rgba(255, 255, 255, 0.03)';
export const SHADOW_XL = '0 24px 48px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.03)';
export const SHADOW_GLOW = '0 0 30px rgba(51, 170, 64, 0.25)';

// Typography
export const FONT_BASE = '"Nunito Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
export const FONT_MONO = '"JetBrains Mono", ui-monospace, SFMono-Regular, "SF Mono", Menlo, Monaco, Consolas, monospace';

export const FONT_SIZE_XXS = '12px';
export const FONT_SIZE_XS = '14px';
export const FONT_SIZE_SM = '16px';
export const FONT_SIZE_MD = '18px';
export const FONT_SIZE_LG = '24px';
export const FONT_SIZE_XL = '32px';
export const FONT_SIZE_XXL = '36px';
export const FONT_SIZE_XXXL = '48px';

export const FONT_WEIGHT_NORMAL = '400';
export const FONT_WEIGHT_MEDIUM = '500';
export const FONT_WEIGHT_SEMIBOLD = '600';
export const FONT_WEIGHT_BOLD = '700';

// Spacing
export const SPACING_XXS = '4px';
export const SPACING_XS = '8px';
export const SPACING_SM = '10px';
export const SPACING_MD = '16px';
export const SPACING_LG = '20px';
export const SPACING_XL = '30px';
export const SPACING_XXL = '40px';
export const SPACING_XXXL = '50px';

// Animation
export const DURATION_FAST = '120ms';
export const DURATION_NORMAL = '200ms';
export const DURATION_SLOW = '350ms';
export const EASING_DEFAULT = 'cubic-bezier(0.4, 0, 0.2, 1)';
export const EASING_IN = 'cubic-bezier(0.4, 0, 1, 1)';
export const EASING_OUT = 'cubic-bezier(0.16, 1, 0.3, 1)';
export const EASING_INOUT = 'cubic-bezier(0.4, 0, 0.2, 1)';
export const EASING_SPRING = 'cubic-bezier(0.34, 1.56, 0.64, 1)';

// Breakpoints
export const BREAKPOINT_XS = 480;
export const BREAKPOINT_SM = 640;
export const BREAKPOINT_MD = 800;
export const BREAKPOINT_LG = 1024;
export const BREAKPOINT_XL = 1280;
